<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <h5 class="form-header">Nueva Cuenta Bancaria</h5>
                <div class="form-desc">Adición de una nueva categoria de cuenta bancaria</div>
                <div class="row">
                  <div class="col-sm-3 col-md-2">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.id && current.errors.id.length > 0 }"
                      >Id</label>
                      <input
                        v-model="current.id"
                        autofocus="autofocus"
                        class="form-control"
                        placeholder="Id"
                        type="text"
                        v-bind:class="{ 'is-invalid': current.errors.id && current.errors.id.length > 0 }"
                      >
                      <small
                        v-if="current.errors && current.errors.id"
                        class="form-text text-danger"
                      >{{ current.errors.id[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-9 col-md-10">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.nombre && current.errors.nombre.length > 0 }"
                      >Nombre</label>
                      <input
                        v-model="current.nombre"
                        class="form-control"
                        placeholder="Nombre"
                        v-bind:class="{ 'is-invalid': current.errors.nombre && current.errors.nombre.length > 0 }"
                        type="text"
                      >
                      <small
                        v-if="current.errors && current.errors.nombre"
                        class="form-text text-danger"
                      >{{ current.errors.nombre[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                      <div class="form-group">
                        <label
                          v-bind:class="{ 'text-danger': current.errors.banco && current.errors.banco.length > 0 }"
                        >Banco</label>
                        <select
                          class="form-control"
                          autofocus="autofocus"
                          v-model="current.banco"
                          @change="refreshData"
                          @input="$emit('input', $event.target.value)"
                        >
                          <option
                            v-for="(c, key) in bancos"
                            :value="c.id"
                            :key="key"
                          >{{ c.nombre }}</option>
                        </select>
                        <small
                          v-if="current.errors && current.errors.banco"
                          class="form-text text-danger"
                        >{{ current.errors.banco[0] }}</small>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              checked
                              class="form-check-input"
                              name="optionsRadios"
                              v-model="current.estatus"
                              type="radio"
                              value="true"
                            >Activo
                          </label>
                        </div>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              class="form-check-input"
                              v-model="current.estatus"
                              name="optionsRadios"
                              type="radio"
                              value="false"
                            >Inactivo
                          </label>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="form-buttons-w">
                  <button class="btn btn-primary" type="submit">Guardar</button>
                  <router-link class="btn btn-default" :to="{ name: 'cat-cuentas-bancarias', params: {  }}">
                    <i class="fa fa-back"></i>
                    Volver al Listado
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CuentaBancariaService from "@/services/catalogos/CuentaBancariaService";
import Notifications from "@/notifications/notifications";


export default {
  data() {
    return {
      current: {
        errors: {}
      }
    };
  },
  computed: {
    ...mapGetters({
      bancos: "catalogos/bancos"
    }),
  },
  mounted() {
    this.$store.dispatch("catalogos/bancos", {
      quitar_paginacion: true
    });
    if (this.$route.params.id) {
      CuentaBancariaService.getById(this.$route.params.id).then(response => {
        this.current = response.data;
        this.current.errors = [];
        this.current.id;
        this.refreshData();
    });
}
  this.refreshData();
},
  methods: {
    refreshData() {
      let self = this;
      self.$store.dispatch("catalogos/bancos", {
        activa: true,
        banco: self.current.banco,
        quitar_paginacion: true
      });
    },
guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, self.current);
      delete current.image;
      if (this.$route.params.id) {
        current.pk = this.$route.params.id;
        delete current.id;
      }
      CuentaBancariaService.save(current)
        .then(res => {
          self.current = res.data;
          self.current.id;
          self.current.errors = {};
          Notifications.alert.success(
            "Producto",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cat-cuentas-bancarias-editar",
            params: { id: self.current.id }
          });
        })
        .catch(error => {
          Vue.nextTick(function() {
            self.current.errors = Object.assign({}, error.response.data);
            console.log(self.current.errors);
          });
        });
    },
    showModal(e) {
      e.preventDefault();
    }
  }
};
</script>
